import { createRoute } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../../route';
import {
  procurementFilterSearchSchema,
  recordFilters,
  rememberFilters,
} from './procurementFilters';

/**
 * The one place the procurement filters live. Forecast Summary, Forecast
 * Details, the Replenishment board and Purchase Order Status are its children, so each of their URLs
 * carries the same validated filters and every navigation between them keeps
 * them. See procurementFilters.ts for the rules.
 *
 * Pathless: it adds nothing to a URL and renders only its child.
 */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  id: 'procurement-filters',
  validateSearch: procurementFilterSearchSchema,
  search: { middlewares: [rememberFilters] },
  beforeLoad: ({ search, preload }) => recordFilters(search, preload),
});
